import { useState, useEffect } from 'react';
import { CONFIG } from '../constants/config';

export const useCountdown = () => {
  const [countdown, setCountdown] = useState({ 
    days: 0, 
    hours: 0, 
    minutes: 0, 
    message: '',
    show: false // New field to control visibility
  });

  useEffect(() => {
    const updateCountdown = () => {
      if (navigator.geolocation) {
        const options = {
          timeout: 5000,
          maximumAge: 0
        };
        
        navigator.geolocation.getCurrentPosition((position) => {
          const { latitude, longitude } = position.coords;
          
          // Cape San Blas coordinates
          const csbLat = CONFIG.CAPE_SAN_BLAS_COORDS.lat;
          const csbLon = CONFIG.CAPE_SAN_BLAS_COORDS.lon;
          
          // Check if in the Panhandle (within ~50 miles of Cape San Blas)
          const distance = Math.sqrt(
            Math.pow(latitude - csbLat, 2) + Math.pow(longitude - csbLon, 2)
          );
          
          const now = new Date();
          const checkoutDate = new Date('2025-06-28T12:00:00'); // Saturday noon checkout
          const arrivalDate = new Date('2025-06-22T22:00:00'); // Sunday 10pm arrival
          const mondayMorning = new Date('2025-06-23T00:01:00'); // Monday 12:01 AM
          
          // If in the Panhandle
          if (distance < 0.5) {
            // Only show countdown 2-3 days before checkout
            const daysUntilCheckout = (checkoutDate - now) / (1000 * 60 * 60 * 24);
            
            if (daysUntilCheckout <= 3 && daysUntilCheckout > 0) {
              const diff = checkoutDate - now;
              const days = Math.floor(diff / (1000 * 60 * 60 * 24));
              const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
              
              setCountdown({ 
                days, 
                hours, 
                minutes, 
                message: 'Until checkout 😢', 
                show: true 
              });
            } else {
              // Don't show countdown
              setCountdown({ 
                days: 0, 
                hours: 0, 
                minutes: 0, 
                message: '', 
                show: false 
              });
            }
          }
          // If in Alpharetta area (north GA) or Tampa
          else if ((latitude > 33.5 && latitude < 34.5 && longitude > -84.5 && longitude < -84) || // Alpharetta area
                   (latitude < 28.5 && latitude > 27.5 && longitude > -82.7 && longitude < -82.2)) { // Tampa area
            
            // Before Monday morning, show countdown to Sunday 10pm arrival
            if (now < mondayMorning) {
              const diff = arrivalDate - now;
              
              if (diff > 0) {
                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                
                setCountdown({ 
                  days, 
                  hours, 
                  minutes, 
                  message: 'Until Cape San Blas! 🌅', 
                  show: true 
                });
              } else {
                // Between arrival and Monday morning
                setCountdown({ 
                  days: 0, 
                  hours: 0, 
                  minutes: 0, 
                  message: '', 
                  show: false 
                });
              }
            } else {
              // After Monday morning, don't show countdown
              setCountdown({ 
                days: 0, 
                hours: 0, 
                minutes: 0, 
                message: '', 
                show: false 
              });
            }
          }
          // Other locations - don't show countdown
          else {
            setCountdown({ 
              days: 0, 
              hours: 0, 
              minutes: 0, 
              message: '', 
              show: false 
            });
          }
        }, (error) => {
          // Geolocation error - don't show countdown
          setCountdown({ 
            days: 0, 
            hours: 0, 
            minutes: 0, 
            message: '', 
            show: false 
          });
        }, options);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, CONFIG.COUNTDOWN_UPDATE_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return countdown;
};

export default useCountdown;